import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDbkrTzIlaiBjBqxpAILQTFzESJ2gXWe4k",
  authDomain: "inca-empire.firebaseapp.com",
  projectId: "inca-empire",
  storageBucket: "inca-empire.firebasestorage.app",
  messagingSenderId: "310355106974",
  appId: "1:310355106974:web:00ce4ae7bea4e59cf26f8f",
  measurementId: "G-G62XE2VZFG"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export { onAuthStateChanged };